import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.tapiio.ma/api/v1',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  // ⚠️ On n'utilise PAS withCredentials (car on utilise Bearer token)
})

// ============================================
// Ajouter le token Bearer à chaque requête
// ============================================
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tapio_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ============================================
// Gérer les erreurs 401 (token expiré)
// ============================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('tapio_token')
      localStorage.removeItem('tapio_user')
      if (window.location.pathname.startsWith('/app')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
